import { APP_BASE_HREF, CommonModule, PlatformLocation, registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeFrCh from '@angular/common/locales/fr-CH';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { NgxOtpInputModule } from 'ngx-otp-input';

import { AccountCheckComponent } from './components/account-check/account-check.component';
import { AccountCheckV2Component } from './components/account-check-v2/account-check-v2.component';
import { AllLifeMomentsComponent } from './components/all-life-moments/all-life-moments.component';
import { AlternateCollapsiblePanelComponent } from './components/alternate-collapsible-panel/alternate-collapsible-panel.component';
import { AnimatedBannerComponent } from './components/animated-banner/animated-banner.component';
import { BadgeDateSelectComponent } from './components/badge-date-select/badge-date-select.component';
import { BadgeSelectComponent } from './components/badge-select/badge-select.component';
import { BooleanChoiceComponent } from './components/boolean-choice/boolean-choice.component';
import { CalendlyInlineEmbedComponent } from './components/calendly/calendly-inline-embed/calendly-inline-embed.component';
import { CalendlyPopupEmbedComponent } from './components/calendly/calendly-popup-embed/calendly-popup-embed.component';
import { CardComponent } from './components/card/card.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { BarChartComponent } from './components/charts/bar-chart/bar-chart.component';
import { CollapsibleTabComponent } from './components/collapsible-tab/collapsible-tab.component';
import { CompanyScrollComponent } from './components/company-scroll/company-scroll.componant';
import { ContactModalComponent } from './components/contact-modal/contact-modal.component';
import { ContractSignatureComponent } from './components/contract-signature/contract-signature.component';
import { ContractSignatureV2Component } from './components/contract-signature-v2/contract-signature-v2.component';
import { ContractSignatureV3Component } from './components/contract-signature-v3/contract-signature-v3.component';
import { ContractSignatureYousignComponent } from './components/contract-signature-yousign/contract-signature-yousign.component';
import { CredibilitySectionComponent } from './components/credibility-section/credibility-section.componant';
import { CustomDateComponent } from './components/custom-date/custom-date.component';
import { DocumentUploadFormComponent } from './components/document-upload-form/document-upload-form.component';
import { DocumentUploadFormV2Component } from './components/document-upload-form-v2/document-upload-form-v2.component';
import { DrawerModalComponent } from './components/drawer-modal/drawer-modal.component';
import { EndScreenComponent } from './components/end-screen/end-screen.component';
import { EndScreenV2Component } from './components/end-screen-v2/end-screen-v2.component';
import { FamilyMemberSelectComponent } from './components/family-member-select/family-member-select.component';
import { FamilyMemberSelectV2Component } from './components/family-member-select-v2/family-member-select-v2.component';
import { FilterSubmitButtonsComponent } from './components/filter-submit-buttons/filter-submit-buttons.component';
import { HealthBaseOfferComponent } from './components/flow-offers/base-health-offer/base-health-offer.component';
import { HealthOfferComponent } from './components/flow-offers/health-offer/health-offer.component';
import { FooterComponent } from './components/footer/footer.component';
import { FormButtonsComponent } from './components/form-buttons/form-buttons.component';
import { FormWrapperComponent } from './components/form-wrapper/form-wrapper.component';
import { FormWrapperV2Component } from './components/form-wrapper-v2/form-wrapper-v2.component';
import { GoogleAutocompleteComponent } from './components/google-autocomplete/google-autocomplete.component';
import { HelpTextComponent } from './components/help-text/help-text.component';
import { HelpTextV2Component } from './components/help-text-v2/help-text-v2.component';
import { HorizontalSeparatorComponent } from './components/horizontal-separator/horizontal-separator.component';
import { InfoDisplayerComponent } from './components/info-displayer/info-displayer.component';
import { InfoTooltipComponent } from './components/info-tooltip/info-tooltip.component';
import { InsurancesListComponent } from './components/insurances-list/insurances-list.component';
import { LanguageSwitcherComponent } from './components/language-switcher/language-switcher.component';
import { LifeMomentCardComponent } from './components/life-moment-card/life-moment-card.component';
import { LinearStepperComponent } from './components/linear-stepper/linear-stepper.component';
import { ListAdvantagesComponent } from './components/list-advantages/list-advantages.component';
import { LoadingOffersOfflineScreenComponent } from './components/loading-offers-offline-screen/loading-offers-offline-screen.component';
import { LoadingOffersScreenComponent } from './components/loading-offers-screen/loading-offers-screen.componant';
import { LoadingScreenComponent } from './components/loading-screen/loading-screen.component';
import { LoginComponent } from './components/login/login.component';
import { LoginV2Component } from './components/login-v2/login-v2.component';
import { LtyAdviceComponent } from './components/lty-advice/lty-advice.component';
import { LtyExpertPopupComponent } from './components/lty-expert-popup/lty-expert-popup.component';
import { MultiStepperComponent } from './components/multi-stepper/multi-stepper.component';
import { NumberFlowComponent } from './components/number-flow/number-flow.component';
import { NumberInputComponent } from './components/number-input/number-input.component';
import { NumberInputV2Component } from './components/number-input-v2/number-input-v2.component';
import { OffersSearchComponent } from './components/offers-search/offers-search.component';
import { OffersSearchV2Component } from './components/offers-search-v2/offers-search-v2.component';
import { AcceptOfferModalComponent } from './components/offers-view/accept-offer-modal/accept-offer-modal.component';
import { OffersViewComponent } from './components/offers-view/offers-view.component';
import { ProposalProductsDisplayerComponent } from './components/offers-view/proposal-products-displayer/proposal-products-displayer.component';
import { RejectOfferModalComponent } from './components/offers-view/reject-offer-modal/reject-offer-modal.component';
import { OtpVerifyComponent } from './components/otp-verify/otp-verify.component';
import { OtpVerifyV2Component } from './components/otp-verify-v2/otp-verify-v2.component';
import { PasswordCriteriaComponent } from './components/password-criteria/password-criteria.component';
import { PdfViewerModalComponent } from './components/pdf-viewer-modal/pdf-viewer-modal.component';
import { PoliciesComponent } from './components/policies/policies.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { RegisterComponent } from './components/register/register.component';
import { RegisterV2Component } from './components/register-v2/register-v2.component';
import { ForgotPasswordComponent } from './components/reset-password/forgot-password/forgot-password.component';
import { SetPasswordComponent } from './components/reset-password/set-password/set-password.component';
import { ReviewModalComponent } from './components/review-modal/review-modal.component';
import { SelectComponent } from './components/select/select.component';
import { SelectV2Component } from './components/select-v2/select-v2.component';
import { SelectV2AltComponent } from './components/select-v2-alt/select-v2-alt.component';
import { SharedCancellationComponent } from './components/shared-cancellation/shared-cancellation.component';
import { SharedCancellationV2Component } from './components/shared-cancellation-v2/shared-cancellation-v2.component';
import { SimpleDocumentUploadComponent } from './components/simple-document-upload/simple-document-upload.component';
import { SliderComponent } from './components/slider/slider.component';
import { SliderV2Component } from './components/slider-v2/slider-v2.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SplitDateComponent } from './components/split-date/split-date.component';
import { StackedCardsComponent } from './components/stacked-cards/stacked-cards.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { StorePasswordPopupComponent } from './components/store-password-popup/store-password-popup.component';
import { AnimalFlowSummaryComponent } from './components/summaries/animal-flow-summary/animal-flow-summary.component';
import { BaseBusinessSummaryComponent } from './components/summaries/base-business-summary/base-business-summary.component';
import { BuildingFlowSummaryComponent } from './components/summaries/building-flow-summary/building-flow-summary.component';
import { BusinessAccidentFlowSummaryComponent } from './components/summaries/business-accident-flow-summary/business-accident-flow-summary.component';
import { BusinessBasicFlowSummaryComponent } from './components/summaries/business-basic-flow-summary/business-basic-flow-summary.component';
import { BusinessCyberFlowSummaryComponent } from './components/summaries/business-cyber-flow-summary/business-cyber-flow-summary.component';
import { BusinessFleetFlowSummaryComponent } from './components/summaries/business-fleet-flow-summary/business-fleet-flow-summary.component';
import { BusinessHealthFlowSummaryComponent } from './components/summaries/business-health-flow-summary/business-health-flow-summary.component';
import { BusinessLegalProtectionFlowSummaryComponent } from './components/summaries/business-legal-protection-flow-summary/business-legal-protection-flow-summary.component';
import { BusinessRetirementFlowSummaryComponent } from './components/summaries/business-retirement-flow-summary/business-retirement-flow-summary.component';
import { BusinessTechnicalInstallationFlowSummaryComponent } from './components/summaries/business-technical-installation-flow-summary/business-technical-installation-flow-summary.component';
import { BusinessThingsFlowSummaryComponent } from './components/summaries/business-things-flow-summary/business-things-flow-summary.component';
import { BusinessTransportFlowSummaryComponent } from './components/summaries/business-transport-flow-summary/business-transport-flow-summary.component';
import { BusinessVehicleFlowSummaryComponent } from './components/summaries/business-vehicle-flow-summary/business-vehicle-flow-summary.component';
import { CancellationSummaryComponent } from './components/summaries/cancellation-summary/cancellation-summary.component';
import { CentralisationSummaryComponent } from './components/summaries/centralisation-summary/centralisation-summary.component';
import { BusinessAccidentClaimSummaryComponent } from './components/summaries/claim-summary/business-accident-summary/business-accident-summary.component';
import { BusinessCompanyRcClaimSummaryComponent } from './components/summaries/claim-summary/business-company-rc-summary/business-company-rc-summary.component';
import { BusinessCompanyThingsClaimSummaryComponent } from './components/summaries/claim-summary/business-company-things-summary/business-company-things-summary.component';
import { BusinessHealthClaimSummaryComponent } from './components/summaries/claim-summary/business-health-summary/business-health-summary.component';
import { ClaimSummaryComponent } from './components/summaries/claim-summary/claim-summary.component';
import { GenericBusinessClaimSummaryComponent } from './components/summaries/claim-summary/generic-business-claim-summary/generic-business-claim-summary.component';
import { CollaboratorFlowSummaryComponent } from './components/summaries/collaborator-flow-summary/collaborator-flow-summary.component';
import { ConstructionFlowSummaryComponent } from './components/summaries/construction-flow-summary/construction-flow-summary.component';
import { CurrentInsurerComponent } from './components/summaries/health-flow-summary/current-insurer/current-insurer.component';
import { DoctorComponent } from './components/summaries/health-flow-summary/doctor/doctor.component';
import { HealthFlowSummaryComponent } from './components/summaries/health-flow-summary/health-flow-summary.component';
import { HealthInfoComponent } from './components/summaries/health-flow-summary/health-info/health-info.component';
import { PersonalInfoComponent } from './components/summaries/health-flow-summary/personal-info/personal-info.component';
import { HouseholdFlowSummaryComponent } from './components/summaries/household-flow-summary/household-flow-summary.component';
import { LegalProtectionFlowSummaryComponent } from './components/summaries/legal-protection-flow-summary/legal-protection-flow-summary.component';
import { OfferDisplayComponent } from './components/summaries/offer-display/offer-display.component';
import { PolicyUpdateSummaryComponent } from './components/summaries/policy-update-summary/policy-update-summary.component';
import { GenericRcCompanyCoverageDisplayComponent } from './components/summaries/rc-company-flow-summary/generic-coverage-display/generic-coverage-display.component';
import { RcCompanyFlowSummaryComponent } from './components/summaries/rc-company-flow-summary/rc-company-flow-summary.component';
import { SummarySelectionComponent } from './components/summaries/summary-selection/summary-selection.component';
import { ThirdPillarFlowSummaryComponent } from './components/summaries/third-pillar-flow-summary/third-pillar-flow-summary.component';
import { TravelFlowSummaryComponent } from './components/summaries/travel-flow-summary/travel-flow-summary.component';
import { ValuableObjectsFlowSummaryComponent } from './components/summaries/valuable-objects-flow-summary/valuable-objects-flow-summary.component';
import { VehicleFlowSummaryComponent } from './components/summaries/vehicle-flow-summary/vehicle-flow-summary.component';
import { ToggleComponent } from './components/toggle/toggle.component';
import { TopBarComponent } from './components/top-bar/top-bar.component';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { DateLimitDirective } from './directives/date-limit.directive';
import { IconsModule } from './icons/icons.module';
import { SignIconComponent } from './icons/sign-icon.component';
import { FileSizePipe } from './pipes/file-size.pipe';
import { KeysPipe } from './pipes/keys.pipe';
import { LocalizedDatePipe } from './pipes/localized-date.pipe';
import { FormatCurrencyPipe } from './pipes/replace-spaces.pipe';

export function getBaseHref(platformLocation: PlatformLocation): string {
  return platformLocation.getBaseHrefFromDOM();
}

registerLocaleData(localeFrCh, 'fr-CH');
registerLocaleData(localeEn, 'en');

@NgModule({
  declarations: [
    AcceptOfferModalComponent,
    AccountCheckComponent,
    AccountCheckV2Component,
    AllLifeMomentsComponent,
    AlternateCollapsiblePanelComponent,
    AnimalFlowSummaryComponent,
    AnimatedBannerComponent,
    BadgeDateSelectComponent,
    BadgeSelectComponent,
    BarChartComponent,
    BaseBusinessSummaryComponent,
    BooleanChoiceComponent,
    BuildingFlowSummaryComponent,
    BusinessAccidentClaimSummaryComponent,
    BusinessAccidentFlowSummaryComponent,
    BusinessBasicFlowSummaryComponent,
    BusinessCompanyRcClaimSummaryComponent,
    BusinessCompanyThingsClaimSummaryComponent,
    BusinessCyberFlowSummaryComponent,
    BusinessFleetFlowSummaryComponent,
    BusinessHealthClaimSummaryComponent,
    BusinessHealthFlowSummaryComponent,
    BusinessLegalProtectionFlowSummaryComponent,
    BusinessRetirementFlowSummaryComponent,
    BusinessTechnicalInstallationFlowSummaryComponent,
    BusinessThingsFlowSummaryComponent,
    BusinessTransportFlowSummaryComponent,
    BusinessVehicleFlowSummaryComponent,
    CalendlyInlineEmbedComponent,
    CalendlyPopupEmbedComponent,
    CancellationSummaryComponent,
    CardComponent,
    CarouselComponent,
    CentralisationSummaryComponent,
    ClaimSummaryComponent,
    CollaboratorFlowSummaryComponent,
    CollapsibleTabComponent,
    CompanyScrollComponent,
    ConstructionFlowSummaryComponent,
    ContactModalComponent,
    ContractSignatureComponent,
    ContractSignatureV2Component,
    ContractSignatureV3Component,
    ContractSignatureYousignComponent,
    CredibilitySectionComponent,
    CurrentInsurerComponent,
    CustomDateComponent,
    DateLimitDirective,
    DoctorComponent,
    DocumentUploadFormComponent,
    DocumentUploadFormV2Component,
    DrawerModalComponent,
    EndScreenComponent,
    EndScreenV2Component,
    FamilyMemberSelectComponent,
    FamilyMemberSelectV2Component,
    FileSizePipe,
    FilterSubmitButtonsComponent,
    FooterComponent,
    ForgotPasswordComponent,
    FormatCurrencyPipe,
    FormButtonsComponent,
    FormWrapperComponent,
    FormWrapperV2Component,
    GenericBusinessClaimSummaryComponent,
    GoogleAutocompleteComponent,
    HealthBaseOfferComponent,
    HealthFlowSummaryComponent,
    HealthInfoComponent,
    HealthOfferComponent,
    HelpTextComponent,
    HelpTextV2Component,
    HorizontalSeparatorComponent,
    HouseholdFlowSummaryComponent,
    InfoDisplayerComponent,
    InfoTooltipComponent,
    InsurancesListComponent,
    KeysPipe,
    LanguageSwitcherComponent,
    LegalProtectionFlowSummaryComponent,
    LifeMomentCardComponent,
    LinearStepperComponent,
    ListAdvantagesComponent,
    LoadingOffersOfflineScreenComponent,
    LoadingOffersScreenComponent,
    LoadingScreenComponent,
    LocalizedDatePipe,
    LoginComponent,
    LoginV2Component,
    LtyAdviceComponent,
    LtyExpertPopupComponent,
    MultiStepperComponent,
    NumberFlowComponent,
    NumberInputComponent,
    NumberInputV2Component,
    OfferDisplayComponent,
    OffersSearchComponent,
    OffersSearchV2Component,
    OffersViewComponent,
    OtpVerifyComponent,
    OtpVerifyV2Component,
    PasswordCriteriaComponent,
    PdfViewerModalComponent,
    PersonalInfoComponent,
    PoliciesComponent,
    PolicyUpdateSummaryComponent,
    ProgressBarComponent,
    ProposalProductsDisplayerComponent,
    RcCompanyFlowSummaryComponent,
    RegisterComponent,
    RegisterV2Component,
    RejectOfferModalComponent,
    ReviewModalComponent,
    SelectComponent,
    SelectV2AltComponent,
    SelectV2Component,
    SetPasswordComponent,
    SharedCancellationComponent,
    SharedCancellationV2Component,
    SignIconComponent,
    SimpleDocumentUploadComponent,
    SliderComponent,
    SliderV2Component,
    SpinnerComponent,
    SplitDateComponent,
    StackedCardsComponent,
    StepperComponent,
    StorePasswordPopupComponent,
    SummarySelectionComponent,
    ThirdPillarFlowSummaryComponent,
    ToggleComponent,
    TopBarComponent,
    TravelFlowSummaryComponent,
    UploadFileComponent,
    ValuableObjectsFlowSummaryComponent,
    VehicleFlowSummaryComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    GenericRcCompanyCoverageDisplayComponent,
    IconsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatChipsModule,
    MatExpansionModule,
    MatIconModule,
    MatTooltipModule,
    NgbTooltipModule,
    NgxIntlTelInputModule,
    NgxOtpInputModule,
    PdfViewerModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  exports: [
    AccountCheckComponent,
    AccountCheckV2Component,
    AllLifeMomentsComponent,
    AlternateCollapsiblePanelComponent,
    AnimatedBannerComponent,
    BadgeDateSelectComponent,
    BadgeSelectComponent,
    BarChartComponent,
    BaseBusinessSummaryComponent,
    BooleanChoiceComponent,
    BuildingFlowSummaryComponent,
    BusinessAccidentClaimSummaryComponent,
    BusinessAccidentFlowSummaryComponent,
    BusinessBasicFlowSummaryComponent,
    BusinessCompanyRcClaimSummaryComponent,
    BusinessCompanyThingsClaimSummaryComponent,
    BusinessCyberFlowSummaryComponent,
    BusinessFleetFlowSummaryComponent,
    BusinessHealthClaimSummaryComponent,
    BusinessHealthFlowSummaryComponent,
    BusinessLegalProtectionFlowSummaryComponent,
    BusinessRetirementFlowSummaryComponent,
    BusinessTechnicalInstallationFlowSummaryComponent,
    BusinessThingsFlowSummaryComponent,
    BusinessTransportFlowSummaryComponent,
    BusinessVehicleFlowSummaryComponent,
    CalendlyInlineEmbedComponent,
    CalendlyPopupEmbedComponent,
    CancellationSummaryComponent,
    CardComponent,
    CarouselComponent,
    CentralisationSummaryComponent,
    ClaimSummaryComponent,
    CollapsibleTabComponent,
    CompanyScrollComponent,
    ContactModalComponent,
    ContractSignatureComponent,
    ContractSignatureV2Component,
    ContractSignatureV3Component,
    ContractSignatureYousignComponent,
    CredibilitySectionComponent,
    CurrentInsurerComponent,
    CustomDateComponent,
    DateLimitDirective,
    DoctorComponent,
    DocumentUploadFormComponent,
    DocumentUploadFormV2Component,
    DrawerModalComponent,
    EndScreenV2Component,
    FamilyMemberSelectComponent,
    FamilyMemberSelectV2Component,
    FileSizePipe,
    FilterSubmitButtonsComponent,
    FooterComponent,
    FormatCurrencyPipe,
    FormButtonsComponent,
    FormWrapperComponent,
    FormWrapperV2Component,
    GenericBusinessClaimSummaryComponent,
    GoogleAutocompleteComponent,
    HealthBaseOfferComponent,
    HealthInfoComponent,
    HealthOfferComponent,
    HelpTextComponent,
    HelpTextV2Component,
    HorizontalSeparatorComponent,
    IconsModule,
    InfoDisplayerComponent,
    InfoTooltipComponent,
    InsurancesListComponent,
    KeysPipe,
    LanguageSwitcherComponent,
    LifeMomentCardComponent,
    LinearStepperComponent,
    ListAdvantagesComponent,
    LoadingOffersOfflineScreenComponent,
    LoadingOffersScreenComponent,
    LoadingScreenComponent,
    LocalizedDatePipe,
    LoginComponent,
    LoginV2Component,
    LtyAdviceComponent,
    LtyExpertPopupComponent,
    MatChipsModule,
    MultiStepperComponent,
    NumberFlowComponent,
    NumberInputComponent,
    NumberInputV2Component,
    OffersSearchComponent,
    OffersSearchV2Component,
    OffersViewComponent,
    OtpVerifyComponent,
    PasswordCriteriaComponent,
    PdfViewerModalComponent,
    PersonalInfoComponent,
    PoliciesComponent,
    ProgressBarComponent,
    RcCompanyFlowSummaryComponent,
    RegisterComponent,
    RegisterV2Component,
    SelectComponent,
    SelectV2AltComponent,
    SelectV2Component,
    SharedCancellationComponent,
    SharedCancellationV2Component,
    SignIconComponent,
    SimpleDocumentUploadComponent,
    SliderComponent,
    SliderV2Component,
    SpinnerComponent,
    SplitDateComponent,
    StackedCardsComponent,
    StepperComponent,
    StorePasswordPopupComponent,
    ToggleComponent,
    TopBarComponent,
    UploadFileComponent,
    ValuableObjectsFlowSummaryComponent,
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useFactory: getBaseHref,
      deps: [PlatformLocation],
    },
    { provide: LOCALE_ID, useValue: 'fr-CH' },
    { provide: LOCALE_ID, useValue: 'en' },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UiKitModule {}
